import questionStandartRules from "./questionStandartRules"
export default {
    questionStandartRules
}